import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formWrapper: {
      width: "872px",
      margin: `${theme.spacing(8)} auto 0`,
      maxWidth: "100%",
    },
    disabled: {
      cursor: "not-allowed !important",
      "& input": {
        cursor: "not-allowed !important",
      },
      "& label": {
        cursor: "not-allowed !important",
      },
    },
    SelectInput: {
      flex: 1,
      width: "100%",
      "& + &": {
        marginTop: theme.spacing(10),
        [theme.breakpoints.up("md")]: {
          marginTop: theme.spacing(0),
          maxWidth: 383,
          width: "auto",
        },
      },
    },
    permissionsForm: {
      marginBottom: theme.spacing(12),
    },
    permissionsFormTitle: {
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: theme.spacing(2),
    },
    permissionsTitle: {
      fontSize: 16,
      marginBottom: theme.spacing(2),
      fontWeight: 500,
    },
    permissionsSubtitle: {
      fontSize: 12,
      color: theme.gray500,
      marginBottom: theme.spacing(4),
    },
    permissionsContainer: {
      border: `1px solid ${theme.gray200}`,
      borderRadius: "8px",
      boxShadow: `0px 1px 0px 0px ${theme.gray100}`,
    },
    permissionsHeader: {
      top: 0,
      zIndex: 2,
      position: "sticky",
      backgroundColor: theme.gray50,
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
      borderBottom: `1px solid ${theme.gray100}`,
    },
    permissionsHeaderTitle: {
      width: 630,
      padding: theme.spacing(7, 8),
      [theme.breakpoints.down("lg")]: {
        width: 530,
      },
    },
    permissionsHeaderAccess: {
      display: "flex",
      justifyContent: "center",
      padding: theme.spacing(7, 0),
      flex: 1,
    },
    permissionCategory: {
      padding: theme.spacing(4, 0, 4, 8),
      textTransform: "uppercase",
      fontSize: 16,
      fontWeight: 500,
      backgroundColor: theme.gray50,
      borderTop: `1px solid ${theme.gray100}`,
    },
    permission: {
      width: 630,
      padding: theme.spacing(4, 8),
      justifyContent: "center",
      display: "flex",
      flexDirection: "column",
      minHeight: 84,
      [theme.breakpoints.down("lg")]: {
        width: 530,
      },
    },
    permissionName: {
      textTransform: "uppercase",
      fontSize: 14,
      fontWeight: 500,
      margin: 0,
    },
    permissionDesc: {
      fontSize: 12,
      color: theme.gray500,
      margin: theme.spacing(4, 0, 0),
      lineHeight: "20px",
    },
    permissionAccess: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(7, 0),
      flex: 1,
    },
    divider: {
      borderColor: theme.gray100,
    },
    searchInput: {
      borderRadius: "4px",
      border: `1px solid ${theme.gray200}`,
      height: 36,
      width: 240,
      "& input": {
        textOverflow: "ellipsis",
      },
    },
    noDataInfo: {
      color: theme.gray500,
      fontSize: 12,
      margin: theme.spacing(4, 0),
      textAlign: "center",
    },
  }),
);
